module.exports = __webpack_public_path__ + "img/1902_Schoenaugasse.477d95e0.jpg";